import useTranslation from "next-translate/useTranslation";
import React, { useEffect, useRef, useState } from "react";
import formatUrl from "utils/FormatUrl";
import style from "./widgetCard.module.css";

function index(props) {
  const { lang } = useTranslation("");
  return (
    <div className={style.card}>
      <span className={style.title}>{props.title}</span>
      <p className={style.subTitle}>
        {props.subtitle}
        <span className={style.heading}>{props.heading}</span>
      </p>
      <button className={style.btn}>
        <a
          rel={
            props.buttonLink.includes("list") ||
            props.buttonLink.includes("map") ||
            props.buttonLink.includes("?") ||
            props.buttonLink.includes("conditions") ||
            props.buttonLink.includes("contact")
              ? "nofollow noopener noreferrer noindex"
              : "follow"
          }
          href={formatUrl(`/${props.lang}${props.buttonLink}`, lang)}
        >
          {props.button}
        </a>
      </button>
    </div>
  );
}

export default index;
